import React from "react";
import LegalLayout, { LegalSection } from "@/components/LegalLayout";
import { Lock } from "lucide-react";

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Privacy Policy" testid="privacy-page" icon={Lock} updated="2026">
      <LegalSection heading="1. Information We Collect">
        <p>We collect your <strong>Name, Phone number, Email address, and payment details</strong> in order to authenticate accounts and process subscription and listing payments.</p>
      </LegalSection>

      <LegalSection heading="2. Display of Contact Details">
        <p>By registering on mypropertyas.com, you consent to your contact details being displayed to prospective buyers or tenants so they can reach you regarding your listings and enquiries.</p>
      </LegalSection>

      <LegalSection heading="3. Data Sharing">
        <p>We do <strong>not</strong> sell your data to third parties. Payment details are processed only to complete transactions you initiate.</p>
      </LegalSection>

      <LegalSection heading="4. Cookies & Data Storage">
        <p>We use cookies and local storage to keep you signed in, remember preferences, and improve your experience. Your data is stored securely and retained only as long as necessary to provide our services or meet legal obligations.</p>
      </LegalSection>

      <LegalSection heading="5. Your Rights">
        <p>You have rights over your personal data under the <strong>Information Technology Act, 2000</strong> and the <strong>Digital Personal Data Protection (DPDP) Act</strong>, including the right to access, correct, and request deletion of your data. To exercise these rights, contact our Grievance Officer.</p>
      </LegalSection>
    </LegalLayout>
  );
}
